// /* eslint-disable-off functional/immutable-data */
// /* eslint-disable-off functional/prefer-readonly-type */
import _findIndex from 'lodash/findIndex';
import _orderBy from 'lodash/orderBy';
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { LoadingIconProps } from 'react-select/src/components/indicators';
import useEffectOnce from 'react-use/esm/useEffectOnce';

export type OptionType = {
  label: string;
  value: number;
  isActive: boolean;
  notes?: string;
  color?: string;
  units?: string;
};

//const LoadingIndicator = (props: LoadingIconProps<OptionType>) => {
const LoadingIndicator = (props: any) => {
  return (
    <Spinner animation="border" size="sm" className="m-1" variant="primary" />
  );
};

// function Menu(props: MenuProps<OptionType>) {
//   return <Dropdown.Menu {...props.innerProps}>{props.children}</Dropdown.Menu>;
// }

// function SingleValue(props: SingleValueProps<OptionType>) {
//   return <div {...props.innerProps}>{props.children}</div>;
// }

const formatOptionLabel = ({ value, label, isActive, notes, color }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {isActive ? (
      <>
        <div style={{ color: color ? color : undefined }}>{label}</div>
        <small className="ms-3 text-muted">{notes}</small>
      </>
    ) : (
      <>
        <div style={{ color: color ? color : undefined, fontStyle: 'italic' }}>
          {label}
        </div>
        <small className="ms-3 text-muted">{notes}</small>
      </>
    )}
  </div>
);

//-------------------------------------------------------------------------------

type Props = {
  id?: string;
  className?: string;
  /** Lazy Query for records  id-> data*/
  hook: () => any;
  disabled?: boolean;
  required?: boolean;
  recordLabel?: string;
  recordLabel2?: string;
  recordLabel3?: string;
  formatLabel?: (record: any) => string;
  where?: string;
  /** Default Input Box Value if selected is undefined */
  placeholder: string | undefined;
  isInvalid?: boolean;
  disableInactives?: boolean;
  isMulti?: boolean;
  /** value number  */
  value: number | null | any;
  label: string | null;
  minMenuHeight?: number;
  maxMenuHeight?: number;
  /** On change value */
  onChange?: (option: OptionType | Array<OptionType>) => void;
  onBlur?: () => void;
  height?: number;
};

/*
  Effects:
  1: Once
  2: data
  3: value
  4: where
*/

const CreatableSelectDB: FC<Props> = ({
  id = 'sbdb',
  className,
  hook,
  disabled = false,
  required = false,
  recordLabel = 'description',
  recordLabel2 = 'description2',
  recordLabel3 = 'description3',
  formatLabel = null,
  where = undefined,
  placeholder,
  isInvalid = false,
  disableInactives = false,
  value,
  // label,
  minMenuHeight = 140,
  maxMenuHeight = 300,
  onChange = null,
  onBlur = null,
  isMulti = false,
  height = 22,
}) => {
  //
  //-------------------- Body -----------------------------------------------
  //
  const label = value;
  const [get, { data, loading }] = hook();
  const queryDone = useRef<boolean>(false);
  const initValue = useRef<number | null | Array<OptionType>>(null);
  const initLabel = useRef<string | null>(null);
  // const [selectValue, setSelectValue] = useState<OptionType | [OptionType]>(
  const [selectValue, setSelectValue0] = useState<any>(
    isMulti && Array.isArray(value)
      ? value.map((v) => {
          return {
            value: v.value as string,
            label: v.label as string,
            isActive: true,
            notes: undefined as string,
            color: undefined as string,
            units: undefined as string,
          };
        })
      : {
          value: value,
          label: label,
          isActive: true,
          notes: undefined,
          color: undefined,
          units: undefined,
        }
  );
  const setSelectValue = (value, pos) => {
    // console.log(
    //   `[SelectDB]:${id} SetSelectValue from ${pos} value=`,
    //   value,
    //   ' oldValue=',
    //   selectValue
    // );
    if (value !== selectValue) setSelectValue0(value);
  };

  const [options, setOptions] = useState<Array<OptionType>>([]);
  const [initialWhere, setInitialWhere] = useState(where);
  /**
   * * 1. Τη πρώτη φορά αν έχω value αλλά δεν έχω Label τοτε κάνω request
   */
  useEffectOnce(() => {
    setInitialWhere(where);

    initValue.current = value;
    // initLabel.current = label;
    initLabel.current = value;

    const opt =
      isMulti && Array.isArray(value)
        ? value.map((v) => {
            return {
              value: v.value as string,
              label: v.label as string,
              isActive: true,
              notes: undefined as string,
              color: undefined as string,
              units: undefined as string,
            };
          })
        : {
            value: value,
            label: label,
            isActive: true,
            notes: undefined,
            color: undefined,
            units: undefined,
          };
    setSelectValue(opt, 'Effect 1');

    // console.log(`[SelectDB]:${id} Value:${value} Label:${label} getting from ${recordLabel}`);
    // Αν υπάρχει value χωρις label τότε διάβασε τα options
    if (!Array.isArray(value) && !!value && !label) {
      console.log(`[SelectDB]:${id} make DB request value:${value}`);
      doQuery('Effect 1');
    }
  });

  /**
   * * 2. Οταν ολοκληρωθεί το διάβασμα από τη βάση γεμίζει ο πίνακας
   * *    των επιλογών και ενημερώνω το initLabel αν υπάρχει initValue
   */
  useEffect(() => {
    console.log(`[SelectDB]:${id} useEffect 2 triggered`, selectValue);
    if (!!data && options.length === 0) {
      const propNames = Object.getOwnPropertyNames(data);
      const records =
        !!data[propNames[0]] && !!data[propNames[0]]['data']
          ? data[propNames[0]]['data']
          : [];

      const newOptions: OptionType[] = records.map((record) => {
        let label: string;
        if (formatLabel) label = formatLabel(record);
        else
          label =
            record[recordLabel] +
            (record[recordLabel2] ? ' - ' + record[recordLabel2] : '') +
            (record[recordLabel3] ? ' - ' + record[recordLabel3] : '');
        return {
          value: record.id,
          label: label,
          isActive: record?.isActive ?? true,
          color: record?.color,
          units: record?.units ? record?.units : record?.product?.units ?? '',
        };
      });
      setOptions(_orderBy(newOptions, ['isActive', 'label'], ['desc', 'asc']));
      queryDone.current = true;
      //console.log(`[SelectDB]:${id} new Options:`, newOptions);
      /**
       *  Τωρα που εχουμε τα options, αν υπάρχει αρχική τιμή βρίσκω το label
       */
      if (
        !!initValue.current &&
        !initLabel.current &&
        selectValue?.value === initValue.current
      ) {
        const idx = _findIndex(newOptions, ['value', initValue.current]);
        if (idx >= 0) {
          initLabel.current = newOptions[idx].label;
          setSelectValue({ ...newOptions[idx] }, 'Effect 2.1');
        }
        return;
      }

      if (!!selectValue?.value && !selectValue?.label) {
        const idx = _findIndex(newOptions, ['value', selectValue?.value]);
        if (idx >= 0) {
          const newValue = { ...newOptions[idx] };
          setSelectValue(newValue, 'Effect 2.2');
          !!onChange && onChange(newValue);
        }
      }
    }
    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, [data]);

  /**
   * * 3. Αν υπάρχουν αλλαγές στο value από Props
   */
  useEffect(() => {
    if (isMulti) {
      console.log(`[SelectDB]:${id} useEffect 3 triggered > isMulti return`);
      return;
    }

    if (value !== selectValue?.value) {
      //console.log('[SelectDB] New value prop:', value);
      // Ο χρήστης έσβησε το πεδίο, η τιμή είναι null
      if (value === null) {
        const opt = isMulti
          ? []
          : { value: null, label: null, isActive: false };
        setSelectValue(opt, 'Effect 3.1');
        !!onChange && onChange(opt);
        return;
      }
      // Ο χρήστης Αρχικοποίησε το πεδίο, ολα γυρνούν στα initValues
      if (value === initValue.current) {
        const opt = isMulti
          ? (initValue.current as [OptionType])
          : {
              value: initValue.current,
              label: initLabel.current,
              isActive: true,
            };
        setSelectValue(opt, 'Effect 3.2');
        !!onChange && onChange(opt as any);
        return;
      }
      // Αλλαξε η τιμή όμως δεν έχουμε τα options, θα πρέπει να δωθεί προσωρινά τιμή στο
      // selectValue μονο μέ το value και να εκτελεστεί το query για να έρθουν και τα labels
      // Στη φάση αυτή δεν εκτελώ το τελικό onChange, αφήνω το effect που θα αναλάβει το διάβασμα
      // των data να το κάνει.
      if (!queryDone.current) {
        const opt = { value: value, label: null, isActive: false };
        setSelectValue(opt, 'Effect 3.3');
        doQuery('Effect 3');
        return;
      }
      // Αλλαξε η τιμή και έχουμε τα options. Ψάχνω και αντιγράφω από τα options
      const idx = _findIndex(options, ['value', value]);
      if (idx >= 0) {
        const opt = {
          value: value,
          label: options[idx].label,
          isActive: options[idx].isActive,
          notes: options[idx].notes,
          color: options[idx].color,
          units: options[idx].units,
        };
        setSelectValue(opt, 'Effect 3.4');
        !!onChange && onChange(opt);
        return;
      }
      // Δεν βρέθηκε η τιμή στα options. Προφανώς πρόκειται περί λάθους. Τα μηδενίζω όλα
      const opt = isMulti ? [] : { value: null, label: null, isActive: false };
      setSelectValue(opt, 'Effect 3.5');
      !!onChange && onChange(opt);
      return;
    }

    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, [value]);

  /**
   * * 4. Αν υπάρχουν αλλαγές στο where
   */
  useEffect(() => {
    // Μηδένισε επιλογή και καθάρισε τα options
    //$$##
    console.log(
      `[SelectDB]:${id} Effect 4 [where] value=`,
      value,
      ' where=',
      where,
      'options=',
      options,
      ' initialWhere=',
      initialWhere
    );
    //initialWhere <> where
    if (where !== initialWhere) {
      console.log(
        `[SelectDB]:${id} Effect 4 [where changed from init] where=`,
        where,
        ' initialWhere=',
        initialWhere
      );
      setSelectValue(isMulti ? [] : undefined, 'Effect 4 [where]');
      setOptions([]);
    }
    // //setSelectValue(isMulti ? [] : undefined, 'Effect 4 [where]');
    // setSelectValue(value, 'Effect 4 [where]');
    // setOptions([]);
    // eslint-disable-off-next-line-off react-hooks/exhaustive-deps
  }, [where]);
  //
  //-------------------- Handlers -------------------------------------------
  //

  /**
   * * 1. To handler της αλλαγής τιμής από το select
   */
  const handleChange = useCallback(
    (selectedOption: OptionType, action) => {
      console.log(`[SelectDB]:${id} handleChange`, selectedOption, action);

      if (action.action === 'clear') {
        const opt = isMulti
          ? []
          : {
              value: null,
              label: null,
              isActive: false,
            };
        // console.log('[SelectDB] onChange clear');
        setSelectValue(opt, 'HandleChange.1');
        !!onChange && onChange(opt);
        return;
      }

      if (selectedOption?.value === initValue.current) {
        const opt = {
          value: initValue.current,
          label: initLabel.current,
          isActive: true,
        };
        // console.log(`[SelectDB]:${id} onChange value:${initValue.current}`);
        setSelectValue(opt, 'HandleChange.2');
        !!onChange && onChange(opt);
        return;
      } else {
        const opt = isMulti
          ? selectedOption
          : {
              value: selectedOption.value,
              label: selectedOption.label,
              isActive: selectedOption.isActive,
              notes: selectedOption.notes,
              color: selectedOption.color,
              units: selectedOption.units,
            };
        // console.log(`[SelectDB]:${id} onChange newValue:${selectedOption.value}`);
        setSelectValue(opt, 'HandleChange.3');
        !!onChange && onChange(opt);
        return;
      }
    },
    [onChange]
  );

  /**
   * * 2. To get του query
   */
  const doQuery = (pos) => {
    console.log(`[SelectDB]:${id} doQuery`, pos, where);
    if (where !== undefined) {
      get({ variables: { where } });
    } else {
      get();
    }
  };

  //
  //------------------ STYLING ----------------------------------
  //

  const styles = useMemo(
    () => ({
      container: (base, state) => ({
        ...base,
        flex: 1,
        //display: 'inline-block',
        // width: '250px',
        minHeight: '1px',
        //height: '26px',
        //marginBottom: '8px',
        //textAlign: 'left',
        // border: 'none',
      }),
      control: (base, state) => ({
        ...base,
        height: `${height}px`,
        minHeight: `${height}px`,
        backgroundColor: disabled
          ? '#e9ecef'
          : required
          ? 'lightYellow'
          : '#fff',
        borderWidth: '1px',
        boxShadow: !state.isFocused
          ? 'inset 0 1px 1px #00000013'
          : isInvalid
          ? '0 0 0 .2rem #dc354560'
          : '0 0 0 .2rem #007bff40',

        borderColor: isInvalid ? '#dc3545' : '#ced4da',
        '&:hover': {
          borderColor: isInvalid ? '#dc3545' : '#ced4da',
          //   borderColor: state.isFocused ? '#ced4da' : isInvalid ? '#dc3545' : '#ced4da',
        },
      }),
      input: (base, state) => ({
        ...base,
        minHeight: '1px',
        marginTop: '0px',
      }),
      indicatorsContainer: (base, state) => ({
        ...base,
        height: `${height}px`,
        minHeight: '1px',
      }),
      dropdownIndicator: (base, state) => ({
        ...base,
        paddingTop: '0',
        paddingBottom: '0',
        minHeight: '1px',
        // color: '#757575',
      }),
      indicatorSeparator: (base, state) => ({
        ...base,
        minHeight: '1px',
        height: `${height - 2}px`,
        marginTop: '0px',
        marginBottom: '0px',
      }),
      clearIndicator: (base, state) => ({
        ...base,
        paddingTop: '0',
        paddingBottom: '0',
        minHeight: '1px',
      }),
      valueContainer: (base, state) => ({
        ...base,
        minHeight: '1px',
        height: `${height}px`,
        paddingTop: '0',
        paddingBottom: '0',
      }),
      singleValue: (base, state) => ({
        ...base,
        color: '#495057',
        minHeight: '1px',
        paddingTop: '1',
        paddingBottom: '1',
      }),
      multiValue: (base, state) => ({
        ...base,
        marginTop: '1px',
      }),
      multiValueLabel: (base, state) => ({
        ...base,
        paddingTop: '1px',
        paddingBottom: '0px',
      }),
      loadingIndicator: (base, state) => ({
        ...base,
        paddingTop: '1',
        paddingBottom: '1',
        minHeight: '1px',
        color: '#007bff80',
      }),
      noOptionsMessage: (base, state) => ({
        ...base,
        color: '#dc3545',
      }),
      menu: (base, state) => ({
        ...base,
        zIndex: 3,
        marginTop: '0px',
        borderTopLeftRadius: '0px',
        borderTopRightRadius: '0px',
      }),
      option: (base, state) => ({
        ...base,
        paddingTop: '4px',
        paddingBottom: '4px',
      }),
    }),
    [disabled, isInvalid, required]
  );

  //
  //-------------------- Render ----------------------------------------------
  //
  // useWhyDidYouUpdate(`[SelectDB]:${id} `, {
  //   className,
  //   hook,
  //   disabled,
  //   recordLabel,
  //   where,
  //   placeholder,
  //   isInvalid,
  //   value,
  //   label,
  //   minMenuHeight,
  //   maxMenuHeight,
  //   onChange,
  //   onBlur,
  //   get,
  //   data,
  //   loading,
  //   initValue: initValue.current,
  //   initLabel: initLabel.current,
  //   selectValue,
  //   options,
  // });

  // console.log('$$$ selectValue $$$', selectValue);
  return (
    <CreatableSelect
      className={className}
      styles={styles}
      isDisabled={disabled}
      isSearchable={true}
      isClearable={true}
      placeholder={placeholder}
      onMenuOpen={() => doQuery('OnMenuOpen')}
      onFocus={() => doQuery('OnFocus')}
      value={selectValue}
      // value={[{ value: 1, label: 'one' }]}
      // defaultValue={selectValue}
      onChange={handleChange}
      onBlur={onBlur}
      options={options as any}
      isLoading={loading}
      loadingMessage={() => null}
      noOptionsMessage={() => null}
      menuPlacement="auto"
      maxMenuHeight={maxMenuHeight}
      minMenuHeight={minMenuHeight}
      components={{ LoadingIndicator }}
      formatOptionLabel={formatOptionLabel}
      isOptionDisabled={(option) =>
        option.isActive === false && disableInactives
      }
      //isMulti={isMulti}
    />
  );
};

export default CreatableSelectDB;

